import {
  Component,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ProfileService } from 'src/app/services/profile.service';
@Component({
  standalone: false,
  selector: 'app-keuangan-saldo',
  templateUrl: './keuangan-saldo.component.html',
  styleUrls: ['./keuangan-saldo.component.scss'],
})
export class KeuanganSaldoComponent {
  loading: boolean = true;
  private profileSubscription!: Subscription;
  isEnterprise: boolean = false;

  constructor(
    private profileService: ProfileService,
  ) { }

  ngOnInit(): void {
    this.getProfile();
    setTimeout(()=>{
      this.loading = false
    }, 1000)
  }

  getProfile() {
    this.profileSubscription = this.profileService.profileData$.subscribe((data) => {
      if (data) {
        this.isEnterprise = data.rajaongkir_level === 3;
      }
    });
  }
}
